import { render, staticRenderFns } from "./registar.vue?vue&type=template&id=3719643f&"
import script from "./registar.vue?vue&type=script&lang=js&"
export * from "./registar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports